export default "__VITE_ASSET__ad534086__"